var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ErrorCode } from 'react-dropzone';
var AdditionalInfoErrorCodes = __assign(__assign({}, ErrorCode), { FileNameTooLong: 'file-name-too-long', InvalidFileName: 'invalid-file-name' });
export default AdditionalInfoErrorCodes;
//# sourceMappingURL=AdditionalInfoErrorCodes.js.map